/**
 * Sanitize a browser hostname for use in app-owned keys such as Firebase paths
 * and document IDs.
 *
 * We intentionally strip punctuation like dots and hyphens, but we must keep
 * digits so hosts such as `bips1.bips.tech` and `bips12.bips.tech` do not
 * collapse onto the same key.
 */
export const sanitizeHostname = (hostname: string) =>
  hostname.replace(/[^a-zA-Z0-9 ]/g, '');
